<template>
  <label
    role="checkbox"
    :class="className"
    :aria-checked="ariaChecked"
  >

    <span
      v-if="formLabel"
      class="label"
    >{{ formLabel }}</span>

    <input
      type="checkbox"
      class="input"
      :checked="toggled"
      @change.stop="toggle"
    />
    <div
      class="core"
      :style="coreStyle"
    >
      <div
        class="button"
        :style="buttonStyle"
      />

      <template v-if="labels">
        <span
          v-if="toggled"
          class="label -left"
          :style="labelStyle"
          v-html="labelChecked"
        />
        <span
          v-else
          class="label -right"
          :style="labelStyle"
          v-html="labelUnchecked"
        />
      </template>
    </div>
  </label>
</template>

<script>

const constants = {
  labelChecked: 'Sim',
  labelUnchecked: 'Não',
  width: 80,
  height: 40,
  margin: 3
}

const contains = (object, title) => {
  return typeof object === 'object' && object.hasOwnProperty(title)
}

const px = v => v + 'px'

export default {
  name: 'ToggleButton',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    sync: {
      type: Boolean,
      default: false
    },
    labels: {
      type: [Boolean, Object],
      default: false,
      validator (value) {
        return typeof value === 'object'
          ? (value.checked || value.unchecked)
          : typeof value === 'boolean'
      }
    },
    formLabel: {
      type: String,
      default: ''
    },
    height: {
      type: [Number, String],
      default: constants.height
    },
    width: {
      type: [Number, String],
      default: constants.width
    }
  },
  data () {
    return {
      toggled: this.value
    }
  },
  computed: {
    className () {
      let { toggled, disabled } = this

      return [
        'c-toggle', {
          '-toggled': toggled,
          '-disabled': disabled
        }
      ]
    },

    ariaChecked () {
      if (!this.toggled) return 'false'
      return this.toggled.toString()
    },

    coreStyle () {
      return {
        width: px(this.width),
        height: px(this.height),
        borderRadius: px(Math.round(this.height / 2))
      }
    },

    buttonRadius () {
      return this.height - constants.margin * 2
    },

    distance () {
      return px(this.width - this.height + constants.margin)
    },

    buttonStyle () {
      return {
        width: px(this.buttonRadius),
        height: px(this.buttonRadius),
        transform: this.toggled
          ? `translate3d(${this.distance}, 3px, 0px)`
          : null
      }
    },

    labelStyle () {
      return {
        lineHeight: px(this.height)
      }
    },

    labelChecked () {
      return contains(this.labels, 'checked')
        ? this.labels.checked
        : constants.labelChecked
    },

    labelUnchecked () {
      return contains(this.labels, 'unchecked')
        ? this.labels.unchecked
        : constants.labelUnchecked
    }
  },
  watch: {
    value (value) {
      if (this.sync) {
        this.toggled = value
      }
    }
  },
  methods: {
    toggle (event) {
      if (this.disabled) return

      this.toggled = !this.toggled
      this.$emit('input', this.toggled)
      this.$emit('change', {
        value: this.toggled,
        srcEvent: event
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@styles/convenia-components/reference.scss';

$c-toggle-font-size: 13px !default;
$c-toggle-label-font-size: 10px !default;
$c-toggle-font-family: $c-font-family-base !default;

$c-toggle-unchecked-background: #bec1d4 !default;
$c-toggle-checked-background: #4CAD50 !default;
$c-toggle-label-color: #8c92b2 !default;

.c-toggle {
  & {
    display: inline-block;
    position: relative;
    overflow: hidden;
    vertical-align: middle;
    user-select: none;
    font-size: $c-toggle-font-size;
    &:not(.-disabled) { cursor: pointer; }
    &.-disabled {
      cursor: not-allowed;
      opacity: 0.3;
    }
  }

  & > .label {
    color: $c-toggle-label-color;
    font-size: $c-toggle-label-font-size;
    text-transform: uppercase;
    margin-bottom: inner-base(0.5);
    display: block;
    line-height: 1;
  }

  & > .input { display: none; }

  & > .core { @extend %c-toggle-core; }

  &.-toggled .core {
    background: $c-toggle-checked-background;
  }
}

%c-toggle-core {
  & {
    display: block;
    position: relative;
    outline: 0;
    margin: 0;
    transition: border-color .3s, background-color .3s;
    will-change: border-color, background-color;
    user-select: none;
    background: $c-toggle-unchecked-background;
  }

  & > .button {
    display: block;
    position: absolute;
    overflow: hidden;
    top: 0;
    left: 0;
    z-index: 3;
    transition: transform 0.3s ease;
    transform: translate3d(3px, 3px, 0);
    border-radius: 100%;
    background-color: #fff;
  }

  & > .label {
    position: absolute;
    bottom: 0;
    color: white;
  }

  & > .label.-left { left: 10px; }
  & > .label.-right { right: 10px; }
}
</style>



// WEBPACK FOOTER //
// src/components/convenia-components/CToggle.vue